import * as React from 'react'
import { useController } from 'react-hook-form'
import * as S from '../SellerVerification.styles'
import type { Path, FieldValues } from 'react-hook-form'

const TextInput = <T extends FieldValues>({
  name,
  label,
  showError = true,
  loading = false
}: TextInputProps<T>) => {
  const { field, fieldState } = useController({ name })

  return (
    <S.Input hasError={Boolean(fieldState.error)}>
      {label && <S.FormLabel htmlFor={name}>{label}</S.FormLabel>}

      {loading ? (
        <S.InputLoading data-testid="text-loading" />
      ) : (
        <input id={name} data-testid={name} type="text" {...field} />
      )}

      {fieldState.error && showError && (
        <S.FormHint error>{fieldState.error.message}</S.FormHint>
      )}
    </S.Input>
  )
}

export default TextInput

interface TextInputProps<T extends FieldValues> {
  name: Path<T>
  label?: string
  showError?: boolean
  loading?: boolean
}
